import { FormGroup, FormBuilder } from '@angular/forms';
import { FormCd003Build } from './forms-build/form-cd003-build';

export class FormCd003 extends FormCd003Build {
    public CreateForm(formBuilder: FormBuilder): FormGroup {
        const formulario: FormGroup = formBuilder.group({
            id: [0, []],
            offline: true,
            site_beneficiamento: ['', []],
            data_hora_apontamento: ['', []],
            safra: ['', []],
            hibrido_rnc: ['', []],
            silo_origem: ['', []],
            lote_cs: ['', []],
            lote_tb: ['', []],
            peneira: ['', []],
            equipamentos_utilizados: ['', []],
            controle_analise_ca: ['', []],
            previa_numero_passada: ['', []],
            quebradas_g: ['', []],
            quebradas_severas_g: ['', []],
            ardidas_g: ['', []],
            ardidas_severas_g: ['', []],
            furadas_leves_g: ['', []],
            furadas_severas_g: ['', []],
            // furadas_lagarta_g: ['', []],
            // furadas_percevejo_g: ['', []],
            // furadas_roedores_g: ['', []],
            silk_cut_g: ['', []],
            silk_cut_severas_g: ['', []],
            popped_kernel_g: ['', []],
            popped_kernel_severas_g: ['', []],
            inerte_g: ['', []],
            presenca_sabugo_ou_pedunculo: ['', []],
            presenca_outras_sementes_especies: ['', []],
            total_defeitos_prc: ['', []],
            total_defeitos_leves_prc: ['', []],
            total_defeitos_severos_prc: ['', []],
            resultado_descriminado_caso_reprovado: ['', []],
            resultado: ['', []],
            repasse_color_sendo_descartado: ['', []],
            peso_g_semente_boa_cinco_segundos: ['', []],
            peso_g_semente_boa_dez_segundos: ['', []],
            peso_g_descarte_sessenta_segundos_coluna_ar: ['', []],
            peso_g_descarte_sessenta_segundos_color_sorter: ['', []],
            peso_g_descarte_dez_segundos_densimetrica: ['', []],
            peso_g_descarte_dez_segundos_coluna_ar: [null, []],
            peso_g_descarte_dez_segundos_color_sorter: [null, []],
            vazao_semente_boa_color_sorter_ton_h: ['', []],
            vazao_descarte_coluna_ar_kg_h: ['', []],
            vazao_descarte_color_sorter_kg_h: ['', []],
            vazao_descarte_densimetrica_kg_h: ['', []],
            peso_g_semente_boa_amostra_descarte_cem_g_coluna_ar: ['', []],
            peso_g_defeitos_amostra_boa_cem_g_col_ar: ['', []],
            prc_semente_boa_descarte_coluna_ar: ['', []],
            prc_defeitos_bica_boa_col_ar: ['', []],
            peso_g_semente_boa_amostra_descarte_cem_g_color_sorter: ['', []],
            peso_g_defeitos_amostra_boa_cem_g_color_sorter: ['', []],
            prc_semente_boa_descarte_color_sorter: ['', []],
            prc_defeitos_bica_boa_color_sorter: ['', []],
            peso_g_semente_boa_amostra_descarte_cem_gramas_densimetrica: ['', []],
            prc_semente_boa_descarte_densimetrica: ['', []],
            peso_hectolitrico_fracao_boa_densimetrica: ['', []],
            peso_hectolitrico_fracao_descarte_densimetrica: ['', []],
            diferenca_peso_hectolitrico_densimetrica: ['', []],
            semente_boa_dez_segundos_g: ['', []],
            perda_boa_prc: ['', []],
            defeitos_prc: ['', []],
            descarte_total_prc: ['', []],
            avaliacao_final: ['', []],
            peso_estimado_kg: ['', []],
            silo_destino: ['', []],
            usuario: ['', []],
            observacao: ['', []],
            created_by: ['', []],
            numero_campo: ['', []],
            linha_processamento: ['', []],
            previa_numero_passada_basica: ['', []],
            regulagem_passe: ['', []],
            numero_regulagem_passe: ['', []],
            peso_g_descarte_sessenta_segundos_coluna_ar2: ['', []],
            peso_hectolitrico_fracao_boa_coluna_ar: [null, []],
            peso_hectolitrico_fracao_descarte_coluna_ar: [null, []],
            responsavel_pela_analise: [null, []],
            responsavel_autorizacao_especial: [null, []],
            justificativa_aprovacao_especial: [null, []],
            diferenca_peso_hectolitrico_coluna_ar: [null, []],
            contrato_juridico: [null, []],
            geracao: [null, []],
            prioridade: [null, []],
            peneira_basica: [null, []],
            equipamentos_basica: [null, []],
            numero_da_regulagem: [null, []],
            medidor_vazao: [null, []],
            turno: [null, []],
        });
        return formulario;
    }
}
